export type KalemTuru = 'Taksit' | 'Pesinat' | 'Kapora';

export const KALEM_TURLERI: { value: KalemTuru; label: string }[] = [
  { value: 'Taksit', label: 'Taksit' },
  { value: 'Pesinat', label: 'Peşinat' },
  { value: 'Kapora', label: 'Kapora' },
];

export const ODEME_TURLERI: { value: string; label: string }[] = [
  { value: 'Nakit', label: 'Nakit' },
  { value: 'BankaHavale', label: 'Banka Havale/EFT' },
  { value: 'Cek', label: 'Çek' },
  { value: 'Senet', label: 'Senet' },
  { value: 'Takas', label: 'Takas' },
  { value: 'Mahsup', label: 'Mahsup (Daire Karşılığı)' },
];

interface VadeliKalem {
  vadeTarihi: string;
  aciklama: string;
}

// Sözleşme tarafı peşinat/kaporayı açıklamanın başından tanıyor ([PESINAT]/[KAPORA] etiketleri,
// taksit özetleri) — tür bu yüzden ayrı alanda değil, açıklamada tutulur.
export const kalemTuruBul = (aciklama?: string | null): KalemTuru => {
  const a = (aciklama || '').trim().toLocaleLowerCase('tr-TR');
  if (a.startsWith('peşinat') || a.startsWith('pesinat')) return 'Pesinat';
  if (a.startsWith('kapora') || a.startsWith('kaparo')) return 'Kapora';
  return 'Taksit';
};

const OTOMATIK_TAKSIT = /^\d+\.\s*taksit$/i;
const TUR_ONCELIK: Record<KalemTuru, number> = { Kapora: 0, Pesinat: 1, Taksit: 2 };

export const vadeyeGoreSirala = <T extends VadeliKalem>(kalemler: T[]): T[] =>
  kalemler
    .map((k, i) => ({ k, i }))
    .sort((a, b) => {
      const da = a.k.vadeTarihi || '9999-12-31';
      const db = b.k.vadeTarihi || '9999-12-31';
      if (da !== db) return da < db ? -1 : 1;
      const ta = TUR_ONCELIK[kalemTuruBul(a.k.aciklama)];
      const tb = TUR_ONCELIK[kalemTuruBul(b.k.aciklama)];
      return ta !== tb ? ta - tb : a.i - b.i;
    })
    .map(x => x.k);

// Yalnızca otomatik "N. Taksit" (veya boş) açıklamalar yeniden numaralanır; peşinat, kapora ve
// elle yazılmış açıklamalar sayıya dahil edilmez, böylece taksitler her zaman 1'den başlar.
export const taksitleriNumarala = <T extends VadeliKalem>(kalemler: T[]): T[] => {
  let n = 0;
  return kalemler.map(k => {
    const a = (k.aciklama || '').trim();
    if (a !== '' && !OTOMATIK_TAKSIT.test(a)) return k;
    n++;
    return { ...k, aciklama: `${n}. Taksit` };
  });
};

export const planiDuzenle = <T extends VadeliKalem>(kalemler: T[]): T[] =>
  taksitleriNumarala(vadeyeGoreSirala(kalemler));

export const kalemTuruDegistir = <T extends VadeliKalem>(kalemler: T[], index: number, tur: KalemTuru): T[] =>
  planiDuzenle(kalemler.map((k, i) => i !== index ? k : {
    ...k,
    aciklama: tur === 'Pesinat' ? 'Peşinat' : tur === 'Kapora' ? 'Kapora' : '',
  }));
